import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintManager_ds_scheduled_for_today_manufacturing_ordersService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get(inParams: { project_id?: number, customer_id?: number, warehouse_ids?: number[] }): Promise<{ result?: { count?: number } }> {
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_scheduled_for_today_manufacturing_orders/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      project_id?: number, customer_id?: number, warehouse_ids?: number[]    }) {
      return false;
    }
}
